﻿import React from 'react';
import { Alignment } from "@blueprintjs/core";
import { FormSwitch, FormHelperText, FormHeading } from 'components/form-fields';
import PropTypes from 'prop-types';
import 'components/form-fields/FormFields.css';

export function FormSwitchList(
    {
        headingLevel = "h4",
        dangerHelperText,
        disabled,
        headingText,
        helperText,
        items,
        loading,
        onChange,
        switchListName
    }
) {  

    function onItemChange(event) {  
        onChange(event);
    }

    return (
        <div className="form-field">
            <FormHeading loading={loading} headingLevel={headingLevel}>{headingText}</FormHeading>
            <FormHelperText loading={loading}>{helperText}</FormHelperText>
            <div className="switchlist">
                {items && items.length > 0 && items.map((item) => {                
                    return (
                        <FormSwitch
                            id={switchListName + item.id}
                            key={item.id}
                            disabled={disabled || item.disabled}
                            onChange={onItemChange}
                            checked={item.checked}
                            loading={loading}
                            label={item.name}
                            identifier={item.id}
                            inline={true}
                            alignment={Alignment.END}
                            labelElement={item.labelElement}
                        ></FormSwitch>
                    );
                })}
            </div>
            <FormHelperText danger={true}>{dangerHelperText}</FormHelperText>
        </div>
    );
}

FormSwitchList.propTypes = {
    headingLevel: PropTypes.string
};